module.exports = __webpack_public_path__ + "img/star-empty-white.646c0f93.svg";